import * as d3 from 'd3'
export default {
  props:['data'],
  data() {
    return {
      sum: 0,
    }
  },
  methods: {
    drawPieChart() {
      let margin = ({top: 10, right: 10, bottom: 20, left: 10})
      let width = 300
      let height = 80
      let min_num=0.05//pie图中需要显示数据的最小百分比，0.05=5%

      //对要填入饼图的数据排序
      this.pie_data.sort((obj1,obj2)=>{
        if(obj1.value<obj2.value) return -1
        else if(obj1.value>obj2.value) return 1
        else return 0
      })
      // 筛选出占比小于5%扇形使其合并
      let data_sum_5={name: 'other',short_name: '其他', value:0, color: 'grey'}
      let final_data = []
      for(let i=0;i<this.pie_data.length;i++){
        let temp = this.pie_data[i]
        if(temp.value / this.sum>=0.05) final_data.push(temp)
        else data_sum_5.value+=temp.value
      }
      final_data.push(data_sum_5)

      let color_array = []
      for(let i=0;i<final_data.length;i++){
        color_array.push(final_data[i].color)
      }
      let color = d3.scaleOrdinal().range(color_array)

      let pie = d3.pie().sort(null).value(d=>d.value)
      let arcs = pie(final_data)

      // 圆的大小
      let arc = d3.arc()
        .innerRadius(0)
        .outerRadius(Math.min(width, height) / 2 - 13)

      // 修改文字距圆心距离
      let arcLabel = (()=>{
        const radius = Math.min(width, height) / 2 - 5
        return d3.arc().innerRadius(radius).outerRadius(radius)
      })()

      var svg = d3.select("#esg_risk_detail_pie").append("svg").attr("viewBox", [0, 0, width, height])
      svg.append("g")
        .attr("stroke", "white")
        .attr("transform", `translate(${width/5},${height/2})`)
        .selectAll("path")
        .data(arcs)
        .join("path")
        .attr("fill", (d, i)=>color(i))
        .attr("d", arc)
        .append("tittle")
        .text(d=>`${d.data.name}: ${d.data.value.toLocaleString()}`)

      svg.append("g")
        .attr("transform", `translate(${width/5},${height/2})`)
        .attr("font-family", "sans-serif")
        .attr("font-size", 3)
        .attr("text-anchor", "middle")
        .selectAll("text")
        .data(arcs)
        .join("text")
        .attr("transform", d => `translate(${arcLabel.centroid(d)})`)
        .attr("fill", "black")
        .call(text => text.append("tspan")
          .attr("y", "-0.4em")
          // .attr("font-weight", "bold")
          .text(d => d.data.value / this.sum > min_num? d.data.short_name : ""))
        .call(text => text.filter(d => (d.endAngle - d.startAngle) > 0.25).append("tspan")
          .attr("x", 0)
          .attr("y", "0.7em")
          .attr("fill-opacity", 0.7)
          .text(d => d.data.value / this.sum > min_num?(d.data.value * 100 / this.sum).toLocaleString() + '%' : ""))



    }
  },
  created() {},
  mounted() {
    this.drawPieChart()
  },
  computed: {
    data_names() {
      return [
        {en: 'finance_transparency', zh: this.$t('insurance.finance_transparency'), zh_short: this.$t('insurance.finance_transparency'), color: '#c942d4'},
        {en: 'business_ethics', zh: this.$t('insurance.business_ethics'), zh_short: this.$t('insurance.business_ethics'), color: '#3b79e6'},
        {en: 'business_competition', zh: this.$t('insurance.business_competition'), zh_short: this.$t('insurance.business_competition'), color: '#5947c9'},
        {en: 'ownership_control', zh: this.$t('insurance.ownership_control'), zh_short: this.$t('insurance.ownership_control'), color: '#43b92f'},
        {en: 'social_impacts', zh: this.$t('insurance.social_impacts'), zh_short: this.$t('insurance.social_impacts_short'), color: '#c92525'},
        {en: 'employee_wellbeing', zh: this.$t('insurance.employee_wellbeing'), zh_short: this.$t('insurance.employee_wellbeing'), color: '#dcc11d'},
        {en: 'labour_relations_practices', zh: this.$t('insurance.labour_relations_practices'), zh_short: this.$t('insurance.labour_relations_practices_short'), color: '#e34477'},
        {en: 'customer_welfare', zh: this.$t('insurance.customer_welfare'), zh_short: this.$t('insurance.customer_welfare_short'), color: '#3bb889'},
        {en: 'human_rights', zh: this.$t('insurance.human_rights'), zh_short: this.$t('insurance.human_rights_short'), color: '#6a6cd0'},
        {en: 'environmental_impact', zh: this.$t('insurance.environmental_impact'), zh_short: this.$t('insurance.environmental_impact_short'), color: '#da9c16'},
        {en: 'waste_hazardous_materials', zh: this.$t('insurance.waste_hazardous_materials'),zh_short: this.$t('insurance.waste_hazardous_materials_short'), color: '#bf3232'},
        {en: 'water_wastewater', zh: this.$t('insurance.water_wastewater'), zh_short: this.$t('insurance.water_wastewater_short'), color: '#f97e4b'},
        {en: 'energy', zh: this.$t('insurance.energy_manage'), zh_short: this.$t('insurance.energy_manage'), color: '#298cc0'},
        {en: 'ghg_emissions', zh: this.$t('insurance.ghg_emissions'), zh_short: this.$t('insurance.ghg_emissions_short'), color: '#e15821'},
      ]
    },
    pie_data() {
      let data = []
      for(let i=0;i<this.data_names.length;i++){
        let obj = {name: '',value: 0, short_name: '', color: '',key: ''}
        obj.name = this.data_names[i].zh
        obj.key = this.data_names[i].en
        obj.color = this.data_names[i].color
        obj.short_name = this.data_names[i].zh_short
        obj.value = this.data[obj.key]
        data.push(obj)
        this.sum+=obj.value
      }
      return data
    }
  }
}



// WEBPACK FOOTER //
// ./src/insurance_esg/js/insurance_esg_detail_pie.js